import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const days = Array.from({
  length: 31
}, (_, i) => String(i + 1));
const years = Array.from({
  length: 10
}, (_, i) => String(2026 - i));
const hours = Array.from({
  length: 12
}, (_, i) => String(i + 1));
const minutes = Array.from({
  length: 60
}, (_, i) => String(i).padStart(2, '0'));
export function EditCourseStatus() {
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  return <div className="space-y-4" data-id="element-687" data-mp="2d5sxc7067xqt">
      <div className="flex items-center justify-between" data-id="element-688" data-mp="2d6ujb6iq64nb">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-689" data-mp="2i4w0tn0i5vwo">
          Edit Course Status
        </h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/profile')} data-id="element-690" data-mp="dayvjut8rd5s">
          ← Back to Profile
        </Button>
      </div>

      <Card data-id="element-691" data-mp="3it3ym6wixr4">
        <CardContent className="pt-6" data-id="element-692" data-mp="3urqjl1x7zea6">
          <form className="space-y-4 max-w-md" data-id="element-693" data-mp="3usrv17i5e2sf">
            <div data-id="element-694" data-mp="w9tbh74fyjnj">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-695" data-mp="wacw4vlh7m59">
                Completed
              </label>
              <div className="flex items-center gap-1 flex-wrap" data-id="element-696" data-mp="rc1l4hjg35lg">
                <select defaultValue="March" className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-697" data-mp="mbdnhd0pnqi9">
                  {months.map(m => <option key={m} data-id="element-698" data-mp="36zrvtigl3qg5">{m}</option>)}
                </select>
                <select defaultValue="2" className="h-8 w-16 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-699" data-mp="32yzkmjo5jbh8">
                  {days.map(d => <option key={d} data-id="element-700" data-mp="2ui8ox7yvsf2b">{d}</option>)}
                </select>
                <select defaultValue="2026" className="h-8 w-20 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-701" data-mp="2zhk78lewbsm0">
                  {years.map(y => <option key={y} data-id="element-702" data-mp="2bssnmifdgiku">{y}</option>)}
                </select>
                <select defaultValue="2" className="h-8 w-14 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-703" data-mp="2bqy1j0sd6kf6">
                  {hours.map(h => <option key={h} data-id="element-704" data-mp="26t69m6rpyyaz">{h}</option>)}
                </select>
                <select defaultValue="33" className="h-8 w-16 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-705" data-mp="1o66ue0jvigcj">
                  {minutes.map(m => <option key={m} data-id="element-706" data-mp="1s6hcgbkxwx7r">{m}</option>)}
                </select>
                <select defaultValue="pm" className="h-8 w-16 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-707" data-mp="274001alvt4dm">
                  <option value="am" data-id="element-708" data-mp="2fvid3cnj742h">am</option>
                  <option value="pm" data-id="element-709" data-mp="2fyo5p1vdco2y">pm</option>
                </select>
              </div>
            </div>

            <div className="pt-2" data-id="element-710" data-mp="2bxcckmdadkq0">
              <Button type="submit" data-id="element-711" data-mp="2pty7pplrovgq">Submit</Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>;
}